import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import CardAguardar from "_+_Portal/_-_Autocheckin/components/genericos/CardAguardar/CardAguardar";
import { useContext, useEffect, useState } from "react";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { ContianerTurnosRecepcionadosLabo } from "./localStyle";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setActualNuevoLabo } from "_+_Portal/_-_Autocheckin/context/action/laboratorio";
import {} from "_+_Portal/_-_Autocheckin/context/action/puntoControl";
import { wsGetTurnosPacienteDelDia } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { PortalContext } from "_+_Portal/context/Provider";
import { OrderTurnosLabo } from "../PagesFun";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";

const TurnosRecepcionadosLabo = () => {
  const {
    laboratorioDispatch,
    turnosAutoCheckInDispatch,
    textosAutoCheckinState,
    turnosSeleccionadosDispatch,
    ubicacionState,
  } = useContext(AutocheckContext);
  const { pasoDispatch } = useContext(AutocheckContext);
  const [loading, setLoading] = useState(true);
  const [listaTurnos, setListaTurnos] = useState([]);

  // aca voy a actualizar los turnos y voy a mostrar cuales estan recepcionados correcctamente
  const { selectDropDownState } = useContext(PortalContext);

  const idPacFamiliar = selectDropDownState?.selectDropDown?.selectGlobal
    ?.pacienteElegido?.paciente?.codigo || false;

  let parsedConfig = {};
  try {
    parsedConfig = JSON.parse(localStorage.getItem("config")) || {};
  } catch (e) {
    parsedConfig = {};
  }
  let filtroHorario =
    textosAutoCheckinState.textosAutoCheckin?.data?.filtroHorario?.orden;
  let minutosToleranciaRecepcion = parsedConfig?.minutosToleranciaRecepcion;
  let minRecepcionVariosTurnos = parsedConfig?.minRecepcionVariosTurnos;
  const coordenadas = ubicacionState?.ubicacion?.data;
  const handleVolver = () => {
    setPaso("HomeLabo")(pasoDispatch);
  };

  const handleClick = (index) => {
    setActualNuevoLabo(index)(laboratorioDispatch);
    setPaso("TurnoRecepcionadoLabo")(pasoDispatch);
  };

  const nextStepTurnosList = (isCorrect, data) => {
    setLoading(false);
    if (isCorrect && data) {
      const turnosOrdenados = OrderTurnosLabo(
        data,
        filtroHorario,
        minutosToleranciaRecepcion,
        minRecepcionVariosTurnos,
        coordenadas,
      );
      const presentes = turnosOrdenados.filter(
        (turno) => turno.estadoProtocolo === 4 && turno.type === "laboratorio",
      );
      setListaTurnos(presentes);
    }
  };

  useEffect(() => {
    wsGetTurnosPacienteDelDia(
      idPacFamiliar,
      nextStepTurnosList,
    )(turnosAutoCheckInDispatch);
  }, []);

  return (
    <>
      <Loading
        dataLoading={loading}
        color="c-white"
        descripcion={"Cargando..."}
      />
      {!loading && (
        <LayoutPasos
          handleClick={handleVolver}
          title={"TURNOS RECEPCIONADOS"}
          subtitle={""}
          type={"no-circle"}
        >
          <ContianerTurnosRecepcionadosLabo
            initial={{ opacity: 0, y: +100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.4 }}
          >
            {listaTurnos.map((turno, key) => {
              return (
                <CardAguardar
                  horaTurno={turno.hora}
                  nombreTurno={turno.especialidad}
                  sedeTurno={turno.centro}
                  flgSoloConsulta={turno.flgSoloConsulta}
                  medico={turno.medico}
                  consultorioTurno={
                    !turno?.consultorio ? "" : turno?.consultorio
                  }
                  handleClick={handleClick}
                  key={key}
                  index={key}
                />
              );
            })}
          </ContianerTurnosRecepcionadosLabo>
        </LayoutPasos>
      )}
    </>
  );
};

export default TurnosRecepcionadosLabo;
